__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['amex-connect-page-wrapper'].baseUrl;
import ModuleContainer from './components/AmexConnectPageWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/amex-connect-core': '^1.8.3-18',
      'react-transition-group': '^4.4.1',
      'gsap': '^3.6.0',
      'react-intl': '^6.2.1',
      '@americanexpress/one-app-module-wrapper': '^3.4.0'
    }
  });
}